import { useEffect, useState } from "react";
import { loadGroupSync } from "../../api/groupSync";
const _prepareFormValues = (backendGroupSync) => {
  const {
    selectionType,
    selection,
    defaultRoles,
    config: { groupSearchBase, groupSearchPattern, teamUniqueIdAttribute, teamNameAttribute }
  } = backendGroupSync;
  return {
    groupSearchBase,
    groupSearchPattern,
    teamDefaultRoles: defaultRoles.join(),
    teamNameAttribute,
    teamUniqueIdAttribute,
    teamSelectionType: selectionType,
    teamSelection: selection,
    synchronizeGroups: true
  };
};
const useInitialGroupSyncValues = (backendId, initialFormValues) => {
  const [backendGroupSync, setBackendGroupSync] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  useEffect(() => {
    if (backendId) {
      loadGroupSync(backendId).then((result) => {
        if (result && result.backend) {
          setBackendGroupSync(result.backend);
        }
        setFinishedLoading(true);
      }).catch(() => {
        setFinishedLoading(true);
        setBackendGroupSync(void 0);
      });
    }
  }, [backendId]);
  return {
    finishedLoading: backendId ? finishedLoading : true,
    formValues: backendGroupSync ? _prepareFormValues(backendGroupSync) : initialFormValues
  };
};
export default useInitialGroupSyncValues;
